import Service from '../services/SystemSettingsService';
export default{
    computed: {
        systemSettings() {
            return window.SystemSettings || {};
        },
    },

    methods: {
        sysSetting(name, defaultVal = null) {
            if (!this.systemSettings) {
                return defaultVal;
            }
            return this.systemSettings[name] || defaultVal;
        },

        loadSystemSettings () {
            Service.loadSettings().then(res => {
                window.SystemSettings = res.data;
            })
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/SystemSettings.js